import React, { FC } from 'react';
import { useDispatch } from 'react-redux';

import { formatPhone } from 'src/actions/shared/phonesHelper';
import Delete from 'src/presentation/components/pages/shared/rowActions/DeleteV2';
import whatsAppSenderResource from 'src/actions/channels/whatsAppSenderResource';

type SenderRowActionProps = {
  dataAid?: string;
  item: {
    displayName: string;
    phoneNumber: string;
    id: string;
    sid: string;
  };
};

const WHATSAPP_SENDER_DELETE_TIMEOUT = 10 * 1000; // 10 seconds

const SenderRowActions: FC<SenderRowActionProps> = ({ item }) => {
  const dispatch = useDispatch();
  const phoneNumber = formatPhone(item.phoneNumber);

  const onDelete = () => {
    dispatch(
      whatsAppSenderResource.effects.remove({ sid: item.sid, phoneNumber }, { timeout: WHATSAPP_SENDER_DELETE_TIMEOUT })
    );
  };

  return (
    <Delete
      id={item.id}
      body={ModalContent(phoneNumber)}
      dataAidPrefix="whatsapp-sender"
      onDelete={onDelete}
      title="Remove WhatsApp Account from Gladly"
    />
  );
};

function ModalContent(phoneNumber) {
  return (
    <>
      The phone number <b>{phoneNumber}</b> will no longer be connected to a WhatsApp account in Gladly. However, all
      previous communications from this account will remain visible in the Conversation Timeline.
    </>
  );
}

export default SenderRowActions;
